import * as PIXI from "pixi.js";
import {Container} from "../core/Container";
import {Poly} from "../core/Shape";
import {Sprite} from "../core/Sprite";

export interface IPaperCut extends PIXI.Container {
    initX: number;
    initY: number;
    initScaleX: number;
    initScaleY: number;
    changeParent(parent: PIXI.Container): void;
    killTweens(): void;
}

export class PaperCutSprite extends Sprite implements IPaperCut {

    public initX: number = 0;
    public initY: number = 0;
    public initScaleX: number = 1;
    public initScaleY: number = 1;
}

export class PaperCutPoly extends Container implements IPaperCut {

    public initX: number = 0;
    public initY: number = 0;
    public initScaleX: number = 1;
    public initScaleY: number = 1;

    private _renderTexture?: PIXI.RenderTexture;

    constructor(polygons: number[][]) {
        super();

        for (const polygon of polygons) {
            this.addChild(new Poly(polygon, 0xffffff));
        }
    }

    public destroy(): void {
        if (this._renderTexture) {
            this._renderTexture.destroy(true);
            this._renderTexture = undefined;
        }
        super.destroy();
    }
}
